<template>
  <div>
    <div class="row col-md-12">
      <div class="card card-siak">
        <div class="d-flex justify-content-between align-items-center">
          <div class="title">
            <h1>Prodi Angkatan</h1>
          </div>
          <div class="toolbar">
            <ButtonComponent colors="#3751E4" name="tambah" v-b-modal.modal @click.native="openModal('Tambah')">
            </ButtonComponent>
          </div>
        </div>

        <KTCodePreview>
          <template v-slot:preview>
            <v-card>
              <v-card-title>
                <!-- $func.exportCsv to export csv -->
                <ButtonComponent colors="#17A1FA" name="csv" @click.native="$func.exportCsv">
                </ButtonComponent>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" label="Search" single-line hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="headers" :items="generations" :search="search">
                <template v-slot:item.no="{ index }">
                  {{ index + 1 }}.
                </template>
                <template v-slot:item.status="{ item }">
                  <b-badge v-if="item.status === true" class="mr-1" variant="primary">Aktif</b-badge>
                  <b-badge v-else class="mr-1" variant="danger">Tidak Aktif</b-badge>
                </template>
                <template v-slot:item.action="{ item }">
                  <ButtonComponent colors="#3751E4" name="edit" v-b-modal.modal @click.native="openModal('Edit', item)">
                  </ButtonComponent>
                  <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"></ButtonComponent>
                </template>
              </v-data-table>
            </v-card>
          </template>
        </KTCodePreview>
        <b-modal @ok="onSubmit" id="modal" ok-title="Simpan" ok-variant="primary" cancel-title="Batal"
          cancel-variant="danger" :title="`${statusModal} Angkatan`">
          <b-form>
            <b-form-group v-if="statusModal == 'Edit'" id="input-group-1" label="Status :" label-for="input-1">
              <Select2 v-model="request.status" :options="status"
                :settings="{ settingOption: value, multiple: false, width: '100%' }" />
            </b-form-group>

            <b-form-group label="Angkatan :" label-for="input-1">
              <b-form-input v-model="request.generation_name" type="text" required
                placeholder="Masukkan Angkatan"></b-form-input>
            </b-form-group>

            <b-form-group label="Tahun : " label-for="input-2">
              <vue-number v-model="request.tahun" v-bind="number" required placeholder="Masukkan Tahun"></vue-number>
            </b-form-group>
          </b-form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Select2 from 'v-select2-component';
import { directive } from '@coders-tm/vue-number-format'
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue"
import axios from "axios";

export default {
  data() {
    return {
      code4: {
        search: "",
        headers: [
          {
            text: "No",
            value: "no"
          },
          { text: "Angkatan", value: "angkatan" },
          { text: "Tahun", value: "tahun" },
          { text: "Status", value: "status" },
          { text: "Aksi", value: "action" }
        ],
        desserts: [
          {
            no: 1,
            angkatan: "59",
            tahun: "2021",
            status: 0,
          },
          {
            no: 2,
            angkatan: "60",
            tahun: "2022",
            status: 1,
          },
          {
            no: 3,
            angkatan: "61",
            tahun: "2023",
            status: 1,
          }
        ]
      },
      status: [
        { id: true, text: "Aktif" },
        { id: false, text: "Tidak Aktif" }
      ],
      statusModal: '',
      dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
      request: {
        key: null,
        generation_name: null,
        tahun: null,
        status: null,
        keterangan: null
      },
      prodiKey: this.$route.params.key,
      price: 0,
      number: {
        decimal: ',',
        // separator: '.',
        separator: '',
        prefix: ' ',
        precision: 2,
        masked: false,
      },
      generations: [],
      search: "",
      headers: [
        {
          text: "No",
          value: "no"
        },
        { text: "Angkatan", value: "generation_name" },
        { text: "Tahun", value: "tahun" },
        { text: "Status", value: "status" },
        { text: "Aksi", value: "action" }
      ],
    };
  },
  components: {
    KTCodePreview,
    Select2,
    ButtonComponent
  },
  directives: {
    number: directive,
  },
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Master" },
      { title: "Prodi", route: "/master/study-programs" },
      { title: "Prodi Angkatan" }
    ]);

    await this.getData()
    // set csv export name and data
    this.$store.commit('updateCsvName', { name: 'Data Export Prodi Angkatan', data: this.generations })
  },
  methods: {
    async getData() {
      try {
        const result = await axios.get(`master/generations/${this.prodiKey}/prodi/`)

        if (result.data.meta.code === 200) {
          this.generations = result.data.data;
        } else {
          this.$swal(`Failed`);
        }

      } catch (err) {
          this.$swal(`Failed`);
      }
    },
    openModal(status, itemData = null) {
      this.statusModal = status

      // reset form
      this.request = {
        id_prodi: this.prodiKey,
        key: null,
        generation_name: null,
        tahun: null,
        status: null,
        keterangan: null
      }

      if (status == 'Edit') {
        this.request.key = itemData.key
        this.request.generation_name = itemData.generation_name,
          this.request.tahun = itemData.tahun,
          this.request.status = itemData.status,
          this.request.keterangan = itemData.keterangan
      }
    },
    async onSubmit() {
      const data = this.request

      if (data.key === null) {
        data.status = true
        // store
        this.store(data)
      } else {
        // update
        this.update(data)
      }
    },

    async store(data) {
      try {
        const formData = new FormData()
        formData.append("id_prodi", data.id_prodi)
        formData.append("generation_name", data.generation_name)
        formData.append("tahun", data.tahun)
        formData.append("status", data.status)

        const result = await axios.post(`master/generations`, formData)

        this.refreshData(result, 'Store')
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async update(data) {
      try {
        var formData = {
          id_prodi: data.id_prodi,
          generation_name: data.generation_name,
          tahun: data.tahun,
          status: data.status,
        };

        const result = await axios.put(`master/generations/${data.key}`, formData)

        this.refreshData(result, 'Update')
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async deleteData(key) {
      try {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this item!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            const result = await axios.delete(`master/room/${key}`)
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    refreshData(result, alert) {
      if (result.data.meta.code == 200) {
        this.$swal(`Success ${alert} Data`);
        this.getData()
      } else {
          this.$swal(`Failed`);
      }
    },
  },
  computed: {

    config() {
      let dataConfig = {
        headers: { Authorization: `Bearer ${this.dataLogin.access_token}`, 'Content-Type': 'application/json' }
      }
      return dataConfig
    },
    noIteration() {
      return this.code4.desserts.length + 1
    }
  }
}
</script>